// @ts-nocheck
/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file
import RIcon from './assets/images/R_logo.png';
import emoji from "react-easy-emoji";
import powerBI from './assets/images/powerBi.png';
import pyTorch from './assets/images/pytorch.png';
import tensorFlow from './assets/images/tensorflow.png';
import keras from './assets/images/keras.png';
import tableau from './assets/images/tableau.svg';
import excel from './assets/images/excel.svg';
import sql from './assets/images/sql.svg';
import python from './assets/images/python.svg';
import javascript from './assets/images/javascript.svg';
import aws from './assets/images/aws.svg';
import kiro from './assets/images/kiro.svg';
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 800 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Barsha Pokharel",
  title: "Hello World! I'm Barsha",
  subTitle: emoji(
    `I'm a data professional who builds the SQL pipelines, models, and dashboards that turn messy operational data into decisions teams actually trust. Day-to-day I work across SQL, Power BI, and Python — integrating operational systems, modeling business logic, and automating the reporting that used to live in spreadsheets. I'm actively learning AWS data engineering stack (Glue, Redshift, S3, Lambda) while studying for the AWS Certified Data Engineer certification. Open to Analytics Engineering or Data Engineering roles!`
  ),
  resumeLink:
    "/Barsha%20Pokharel%20Resume.pdf", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links
const socialMediaLinks = {
  // github: "https://github.com/maverickbarsha",
  linkedin: "https://www.linkedin.com/in/barsha-pokharel",
  gmail: "barshapokharel25@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "ANALYST BY TITLE, DATA ENGINEER BY DIRECTION",
  skills: [
    emoji(
      "⚡ Build multi-source ETL pipelines that ingest from SQL databases, marketing APIs, and flat files into unified, analytics-ready models"
    ),
    emoji(
      "⚡ Model business logic in SQL and DAX to produce reusable KPIs and semantic layers that stakeholders can trust"
    ),
    emoji(
      "⚡ Optimize SQL queries and transformations to cut reporting latency and reduce manual data work"
    ),
    emoji(
      "⚡ Enforce data quality and integrity across ingestion, transformation, and reporting layers"
    ),
    emoji(
      "⚡ Design data models that translate operational systems (CRM, CMMS, marketing platforms) into decision-ready structures"
    ),
    emoji(
      "⚡ Automate reporting workflows so analytics moves from ad-hoc pulls to reliable, scheduled delivery"
    ),
    emoji(
      "⚡ Partner with cross-functional teams to translate business questions into data requirements and pipeline specs"
    ),
    emoji(
      "⚡ Extend pipelines with Python and ML where predictive or classification signals add business value"
    ),
  ],


  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      category: "Cloud & AI",
      items: [
        {
          skillName: "AWS",
          icon: aws
        },
        {
          skillName: "Kiro",
          icon: kiro
        }
      ]
    },
    {
      category: "Data & BI",
      items: [
        {
          skillName: "SQL",
          icon: sql
        },
        {
          skillName: "Power BI",
          icon: powerBI
        },
        {
          skillName: "Tableau",
          icon: tableau
        },
        {
          skillName: "Excel",
          icon: excel
        }
      ]
    },
    {
      category: "ML & Deep Learning",
      items: [
        {
          skillName: "PyTorch",
          icon: pyTorch
        },
        {
          skillName: "TensorFlow",
          icon: tensorFlow
        },
        {
          skillName: "Keras",
          icon: keras
        }
      ]
    },
    {
      category: "Languages",
      items: [
        {
          skillName: "Python",
          icon: python
        },
        {
          skillName: "R",
          icon: RIcon
        },
        {
          skillName: "JavaScript",
          icon: javascript
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "La Trobe University",
      logo: require("./assets/images/la_trobe.jpg"),
      subHeaders: ["Masters of Data Science"],
      duration: "February 2022 - November 2023",
      desc: "Melbourne, Australia",
    },
    {
      schoolName: "Pokhara University",
      logo: require("./assets/images/pu.jpg"),
      subHeaders: ["Bachelor of Engineering in Computer Engineering"],
      duration: "September 2015 - September 2019",
      desc: "Kathmandu, Nepal",
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Data Visualization", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Data Modeling and Prediction",
      progressPercentage: "60%"
    },
    {
      Stack: "Programming",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Operations Data Analyst",
      company: "Quikrete",
      companylogo: require("./assets/images/quikrete.png"),
      location: "Atlanta, GA",
      logoScale: 0.9,
      date: "Apr 2026 – Present",
      desc: "Support the Engineering team in keeping operational data accurate and reliable across manufacturing systems.",
      descBullets: [
        "Administer the CMMS (Maintenance Connection) for the Hardscapes and Masonry division — asset hierarchy, preventive maintenance schedules, work order workflows, and user roles — including time- and meter-based PM generation logic and meter reading audits that keep work orders and equipment hours accurate.",
        "Administer the Vorne production monitoring system, maintaining device, part, and rate configuration so production counts and downtime reasons map correctly to each line, and integrating Vorne runtime data with the CMMS so meter-based PMs trigger on actual equipment hours.",
        "Build and maintain SQL queries and Python scripts that extract, clean, and join CMMS and production data into repeatable pipelines, reconciling duplicate assets, orphaned work orders, and missing meter history to keep reporting trustworthy.",
        "Replaced manual, spreadsheet-based reporting with automated Excel and Power BI dashboards covering forklift and loader assets, work order costs, and uptime/downtime, cutting turnaround time and giving the engineering team on-demand access to maintenance and production KPIs.",
        "Led stockroom and asset record cleanup across ~30 Hardscapes and Masonry plants, standardizing naming and decommissioning obsolete locations to improve equipment visibility and support plant operations and engineering decision-making."]
    },
    {
      role: "CMMS Data Administrator",
      company: "JSM Airport Services",
      companylogo: require("./assets/images/jsm.png"),
      location: "Denver, CO",
      logoScale: 0.9,
      date: "Dec 2025 – Apr 2026",
      desc: "Directed the full data lifecycle for the Baggage Handling System within Fiix CMMS.",
      descBullets: [
        "Queried Fiix CMMS to produce daily, weekly, and monthly reports for supervisors, DEN stakeholders, and contractors, surfacing failure and downtime trends that supported root-cause investigations across the Baggage Handling System (BHS).",
        "Tracked preventative-maintenance, ATR, emergency, and work-ticket KPIs across the BHS, and enforced data integrity in Fiix to keep the reporting layer trustworthy.",
        "Documented KPI definitions, system logic, and data processes to improve transparency and knowledge sharing across maintenance and engineering teams."]
    },
    {
      role: "Data Analyst",
      company: "SPICAE",
      location: "Melbourne, Australia",
      companylogo: require("./assets/images/spicae.png"),
      logoScale: 0.9,
      date: "Nov 2023 – Nov 2024",
      desc: "Partnered with a fast-moving consulting team to deliver analytics and BI solutions for enterprise clients.",
      descBullets: [
        "Built and maintained data pipelines in SQL and Power Query to ingest from client SQL databases and CSV exports, applying quality checks and standardization so downstream reporting stayed reliable across engagements.",
        "Modeled business logic in DAX to move KPI calculations out of ad-hoc SQL and into a reusable semantic layer, improving KPI consistency across time periods and business units.",
        "Designed interactive, hierarchical Power BI dashboards on top of the modeled data, cutting manual reporting time by ~40% for client analytics teams."]
    },
    {
      role: "Data Analyst Intern",
      company: "Annecto",
      companylogo: require("./assets/images/annecto.png"),
      location: "Footscray, Australia",
      logoScale: 1.6,
      date: "Mar 2023 – Jun 2023",
      desc: "Collaborated with other interns and full-time engineers to add new features and develop PoC for future developments.",
      descBullets: [
        "Built an ingestion layer that pulled data from five marketing APIs (Google Analytics, Facebook, Instagram, LinkedIn, Twitter), unifying inconsistent schemas into a single reporting model stakeholders could query.",
        "Integrated marketing data with internal operational KPIs to give stakeholders a unified view of customer acquisition and recruitment-journey effectiveness across channels.",
        "Delivered the results through a Power BI dashboard with filtering and segmentation by audience, channel, and demographic enabling campaign teams to adjust strategy in real-time."
      ]
    },
    {
      role: "Business Analyst",
      companylogo:require("./assets/images/sirius_innovatech_engineering_logo.jpg"),
      company: "Sirius Engineering Consultancy",
      location: "Kathmandu, Nepal",
      logoScale: 1.11,
      date: "Dec 2020 – Jan 2022",
      desc: "Contributed to a high-performing team of engineers, leveraging Agile and Scrum methodologies to develop a cutting-edge virtual classroom platform.",
      descBullets: [
"Built core features of a scalable virtual classroom platform in Django — discussion forums, 1:1 chats, video uploads, expert reviews — supporting simultaneous interactions across multiple active courses.",
"Built responsive, user-centric interfaces using Django templating, Bootstrap, and AJAX to deliver dynamic content updates without full-page reloads, enhancing the user experience and platform performance."
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  projects: [
    {
      image: require("./assets/images/news_classifier.webp"),
      projectName: "News classification using PyTorch",
      projectDesc: "Developed PyTorchNewsClassifier utilizing PyTorch framework and created a neural network that categorizes news articles into four distinct categories: Sports, World, Business, and Science Tech with 97% accuracy.",
      footerLink: []
    },
    {
      image: require("./assets/images/university.webp"),
      projectName: "American University Attendance Risk Prediction",
      projectDesc: "Developed a neural network classifier (NN) to identify students at high risk of low attendance based on academic performance, achieving 79% accuracy and enabling the university to support them through targeted interventions.",
      footerLink: []
    },
    {
      image: require("./assets/images/chatex.jpg"),
      projectName: "ChaTex",
      projectDesc: "Created an Android chat application that extends existing chat applications' features by letting users send mathematical equations and expressions in their natural form along with text messages. ChaTeX uses LaTeX for the typesetting of math equations.",
      footerLink: []
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Awards"),
  achievementsCards: [
    {
      title: "Srijana The Innovation",
      subtitles: ["First Prize in Software Competition", "organized by Advanced College of Engineering and Management", "Lalitpur, Nepal"],
      footerLink: []
    },
    {
      title: "Yatra 1.0",
      subtitles: ["First Prize in Software Competition", "organized by National College of Engineering", "Lalitpur, Nepal"],
      imageAlt: "Yatra 1.0",
      footerLink: []
    },
    {
      title: "Programming Competition",
      subtitles: ["First Prize in NOSKode(Python Programming)", "organized by Nepal Open Source Klub", "Lalitpur, Nepal"],
      imageAlt: "Programming Competition",
      footerLink: []
    }
  ],
  display: true // Set false to hide this section, defaults to true
};


const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Want to discuss an interesting opportunity or just want to say hi? My inbox is open for all.",
  email_address: "barshapokharel25@gmail.com"
};

// Blogs Section
const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false",
  blogs: [],
  display: false
};

// Talks Section
const talkSection = {
  title: "TALKS",
  subtitle: "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅",
  talks: [],
  display: false
};

// Podcast Section
const podcastSection = {
  title: "Podcast 🎙️",
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  podcast: [],
  display: false
};

// Stats Section
const statsSection = {
  title: "My Stats",
  stats: [],
  display: false
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  statsSection,
  contactInfo,
  twitterDetails,
  isHireable
};
